import { initializeApp } from "firebase/app";
import {
  getAuth,
  setPersistence,
  browserLocalPersistence
} from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyA6roIb0BJAHJrC5IyWUpXT2fkm2uNVDKU",
  authDomain: "badtameezdil-gamestore.firebaseapp.com",
  projectId: "badtameezdil-gamestore",
  storageBucket: "badtameezdil-gamestore.firebasestorage.app",
  messagingSenderId: "126505287388",
  appId: "1:126505287388:web:d7ddd726373b0c1da13e19"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

export const authPersistence = setPersistence(
  auth,
  browserLocalPersistence
);
